import React from 'react';
import './index.css';
import { BrowserRouter, Routes } from "react-router-dom";
import { routes } from "./routes/routes"
import ScrollToTop from "./ScrollToTop"
import { useState } from "react"
import { Layout, ConfigProvider, theme } from 'antd';
import { Header } from './header';
import useWindowDimensions from "./dist/UseWindowDimensions";

const { Content } = Layout;

export default function Index() {
  const systemDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const [isDarkModeOverride, setIsDarkModeOverride] = useState(systemDarkMode);

  const { width } = useWindowDimensions();
  const small = width < 800;

  return (
    <ConfigProvider
      theme={{
        algorithm: isDarkModeOverride ? theme.darkAlgorithm : theme.defaultAlgorithm,
      }}
    >
      <IndexContent
        isDarkModeOverride={isDarkModeOverride}
        setIsDarkModeOverride={setIsDarkModeOverride}
        small={small}
        width={width}
      />
    </ConfigProvider>
  )
};

function IndexContent({ isDarkModeOverride, setIsDarkModeOverride, small, width }) {
  const contentBg = isDarkModeOverride ? '#0d1526' : '#f1f5f9';

  return (
    <div>
      <React.StrictMode>
        <BrowserRouter>
          <ScrollToTop />
          <Header
            small={small}
            width={width}
            isDarkMode={isDarkModeOverride}
            onToggleDarkMode={() => setIsDarkModeOverride((prev) => !prev)}
          />

          <Layout style={{ background: contentBg }}>
            <Content style={{ padding: 0, background: contentBg }}>
              <Routes>
                { routes(isDarkModeOverride) }
              </Routes>
            </Content>
          </Layout>

          <Footer isDarkMode={isDarkModeOverride} />

        </BrowserRouter>
      </React.StrictMode>
    </div>
  );
}

export function Footer({ isDarkMode }) {
  return (
    <div className="site-footer">
      <div className="container">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
          <div>
            <div className="fw-bold text-white mb-1" style={{ fontSize: 16 }}>
              Dilks Software Solutions
            </div>
            <div className="text-white-50" style={{ fontSize: 13 }}>
              Modern software consulting for ambitious teams
            </div>
          </div>
          <div className="d-flex gap-4">
            <a href="/insights" className="text-white-50" style={{ fontSize: 13, textDecoration: 'none' }}>Insights</a>
            <a href="/changelog" className="text-white-50" style={{ fontSize: 13, textDecoration: 'none' }}>Changelog</a>
            <a href="/contact" className="text-white-50" style={{ fontSize: 13, textDecoration: 'none' }}>Contact</a>
          </div>
          <div className="text-white-50" style={{ fontSize: 12 }}>
            © {new Date().getFullYear()} Andrew Dilks
          </div>
        </div>
      </div>
    </div>
  );
}
